import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import Y from '../../../y18n'
import * as subscriptionActions from '../../../store/subscriptions'
import { Typography } from '@material-ui/core'
import Styles from '../../../common/styles'

const mapStateToProps = state => ({
  subscriptions: state.subscriptions
})

const mapDispatchToProps = dispatch => ({
  subscriptionActions: bindActionCreators(subscriptionActions, dispatch)
})

class DeleteSubscriptionDialog extends Component {
  submitForm (e, id) {
    e.preventDefault()
    this.props.subscriptionActions.deleteSubscription(id).then(res => {
      if (!this.props.subscriptions.dialogLoading) {
        this.props.handleReload()
      }
    })
  }

  render () {
    const { subscriptions, subscriptionActions, classes } = this.props
    if (!subscriptions.active || !subscriptions.delete || subscriptions.new) return null
    return (
      <Dialog
        open={subscriptions.active !== null}
        onClose={() => subscriptionActions.resetDelete()}
        aria-labelledby='delete-subscription-dialog'
        classes={{
          paper: classes.dialogContent
        }}
      >
        {subscriptions.dialogLoading && <LinearProgress />}
        <form onSubmit={e => this.submitForm(e, subscriptions.active.id)}>
          <DialogTitle id='delete-subscription-dialog'>{Y`Are you sure you want to delete this subscription?`}</DialogTitle>
          <DialogContent>
            <Typography variant='body2'>{Y`This can not be undone later!`}</Typography>
            {subscriptions.error &&
              <Typography variant='body2' style={{ color: 'red', marginTop: '20px' }}>
                {Y`${subscriptions.error}`}
              </Typography>}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => subscriptionActions.resetDelete()}
              style={{ marginRight: '20px' }}
            >{Y`Close`}</Button>
            <Button type='submit' variant='raised' style={{ color: 'white', backgroundColor: 'red' }}>
              {Y`Confirm delete`}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}

DeleteSubscriptionDialog = connect(mapStateToProps, mapDispatchToProps)(DeleteSubscriptionDialog)
export default withStyles(Styles)(DeleteSubscriptionDialog)



// WEBPACK FOOTER //
// ./src/pages/subscriptions/containers/delete-subscription-dialog.js